export default {
    template: `
<sw-page class="riccardo-verbund">
    <template #smart-bar-header><h2>Systemzustand</h2></template>

    <template #smart-bar-actions>
        <sw-button :is-loading="isLoading" @click="laden">Aktualisieren</sw-button>
        <sw-button
            variant="primary"
            :disabled="!kannAnfordern"
            :is-loading="fordertAn"
            @click="anfordernOeffnen">
            Knoten hinzunehmen
        </sw-button>
    </template>

    <template #content>
        <sw-card-view>
            <sw-alert v-if="fehler" variant="error" :title="'Konnte den Zustand nicht laden'">{{ fehler }}</sw-alert>

            <sw-card v-if="empfehlung" :title="empfehlung.titel" :class="'rz-empfehlung rz-empfehlung--' + empfehlung.stufe">
                <p class="rz-empfehlung-text">{{ empfehlung.text }}</p>
                <p v-if="standVon" class="rz-stand">Stand: {{ standVon }}</p>
            </sw-card>

            <sw-card v-if="auftrag" title="Laufender Auftrag">
                <p>
                    <strong>{{ auftragText }}</strong><br>
                    Angefordert von {{ auftrag.angefordert_von || 'unbekannt' }} am {{ datum(auftrag.created_at) }}.
                </p>
                <pre v-if="auftrag.protokoll" class="rz-protokoll">{{ auftrag.protokoll }}</pre>
                <p v-else class="rz-stand">Der Verwaltungsserver holt den Auftrag alle zwei Minuten ab.</p>
            </sw-card>

            <sw-card title="Knoten">
                <sw-data-grid
                    v-if="knoten.length"
                    :data-source="knoten"
                    :columns="spalten"
                    :show-selection="false"
                    :show-actions="false"
                    :plain-appearance="true">

                    <template #column-rechnername="{ item }">
                        <span :class="'rz-punkt rz-punkt--' + item.zustand"></span>
                        <strong>{{ item.rechnername }}</strong>
                        <small v-if="item.adresse"> · {{ item.adresse }}</small>
                    </template>

                    <template #column-lastJeKern="{ item }">
                        <span v-if="item.erreichbar">
                            {{ zahl(item.lastJeKern) }} <small>({{ item.kerne }} Kerne)</small>
                        </span>
                        <span v-else>–</span>
                    </template>

                    <template #column-fpmAuslastungProzent="{ item }">
                        <span v-if="item.erreichbar && item.fpmMax">
                            {{ item.fpmKinder }} / {{ item.fpmMax }}
                            <small>({{ item.fpmAuslastungProzent }} %<template v-if="item.fpmPool">, Pool {{ item.fpmPool }}</template>)</small>
                        </span>
                        <span v-else>–</span>
                    </template>

                    <template #column-speicherFreiProzent="{ item }">
                        <span v-if="item.erreichbar">{{ item.speicherFreiProzent }} % frei</span>
                        <span v-else>–</span>
                    </template>

                    <template #column-platteFreiProzent="{ item }">
                        <span v-if="item.erreichbar">
                            {{ item.platteFreiProzent }} % frei
                            <small>({{ zahl(item.platteFreiGb) }} von {{ zahl(item.platteGesamtGb) }} GB)</small>
                        </span>
                        <span v-else>–</span>
                    </template>

                    <template #column-dienste="{ item }">
                        <span v-if="!item.erreichbar">–</span>
                        <span v-else-if="!item.dienste" class="rz-stumm">unbekannt</span>
                        <span v-else>
                            <span v-for="d in dienstListe(item)" :key="d.name" class="rz-dienst">
                                <span :class="'rz-punkt rz-punkt--' + d.zustand"></span>{{ d.text }}
                            </span>
                        </span>
                    </template>

                    <template #column-gemeldetVorSekunden="{ item }">
                        <span v-if="item.erreichbar">vor {{ vorher(item.gemeldetVorSekunden) }}</span>
                        <span v-else class="rz-stumm">stumm seit {{ vorher(item.gemeldetVorSekunden) }}</span>
                    </template>
                </sw-data-grid>

                <sw-empty-state
                    v-else-if="!isLoading"
                    title="Noch keine Meldungen"
                    subline="Die Knoten melden sich beim nächsten Seitenaufruf von selbst." />
            </sw-card>


            <sw-card v-if="datenbank.length" title="Datenbank (Galera)">
                <sw-data-grid
                    :data-source="datenbank"
                    :columns="dbSpalten"
                    :show-selection="false"
                    :show-actions="false"
                    :plain-appearance="true">

                    <template #column-adresse="{ item }">
                        <span :class="'rz-punkt rz-punkt--' + dbZustand(item)"></span>
                        <strong>{{ item.adresse }}</strong>
                        <small> \u00b7 {{ item.rolle }}</small>
                    </template>

                    <template #column-knotenStatus="{ item }">
                        <span v-if="item.erreichbar">
                            {{ item.knotenStatus }}
                            <small v-if="item.imVerbund">({{ item.verbundStatus }}/{{ item.verbundGroesse }})</small>
                        </span>
                        <span v-else class="rz-stumm">{{ item.fehler || 'nicht erreichbar' }}</span>
                    </template>

                    <template #column-verbindungen="{ item }">
                        <span v-if="item.erreichbar">
                            {{ item.verbindungen }} / {{ item.verbindungenMax }}
                            <small>({{ item.verbindungenProzent }} %)</small>
                        </span>
                        <span v-else>\u2013</span>
                    </template>

                    <template #column-bremst="{ item }">
                        <span v-if="item.erreichbar">{{ bremse(item.bremst) }}</span>
                        <span v-else>\u2013</span>
                    </template>

                    <template #column-laufzeitTage="{ item }">
                        <span v-if="item.erreichbar">
                            {{ item.laufzeitTage }} Tage
                            <small>({{ item.fassung }})</small>
                        </span>
                        <span v-else>\u2013</span>
                    </template>
                </sw-data-grid>
                <p class="rz-stand">
                    Geschrieben wird auf den ersten Knoten, gelesen von allen. Ein Knoten darf ausfallen \u2013
                    bei zweien steht der Verbund.
                </p>
            </sw-card>

            <sw-card v-if="speicher" title="Zwischenspeicher (Redis)">
                <template v-if="speicher.erreichbar">
                    <div class="rz-kennzahlen">
                        <div class="rz-kennzahl">
                            <span class="rz-kennzahl-wert">{{ speicherBelegung }}</span>
                            <span class="rz-kennzahl-name">Belegt</span>
                        </div>
                        <div class="rz-kennzahl">
                            <span class="rz-kennzahl-wert">{{ zahl(speicher.eintraege) }}</span>
                            <span class="rz-kennzahl-name">Eintr\u00e4ge</span>
                        </div>
                        <div class="rz-kennzahl">
                            <span class="rz-kennzahl-wert">{{ speicher.trefferProzent === null ? '\u2013' : speicher.trefferProzent + ' %' }}</span>
                            <span class="rz-kennzahl-name">Treffer</span>
                        </div>
                        <div class="rz-kennzahl">
                            <span class="rz-kennzahl-wert">{{ speicher.verbindungen }}</span>
                            <span class="rz-kennzahl-name">Verbindungen</span>
                        </div>
                        <div class="rz-kennzahl">
                            <span class="rz-kennzahl-wert">{{ zahl(speicher.verdraengt) }}</span>
                            <span class="rz-kennzahl-name">Verdr\u00e4ngt</span>
                        </div>
                    </div>
                    <p class="rz-stand">
                        Master {{ speicher.adresse }} · Redis {{ speicher.fassung }} ·
                        läuft seit {{ speicher.laufzeitTage }} Tagen.
                        <template v-if="speicher.verbund">
                            <br>
                            <span :class="'rz-punkt rz-punkt--' + (waechterEinig ? 'ruhig' : 'eng')"></span>
                            {{ waechterText }}
                            <template v-if="speicher.repliken && speicher.repliken.length">
                                · Replik{{ speicher.repliken.length > 1 ? 'en' : '' }}:
                                <span v-for="(r, i) in speicher.repliken" :key="r.adresse">
                                    <template v-if="i">, </template>{{ r.adresse }} ({{ r.zustand }})
                                </span>
                            </template>
                        </template>
                        <template v-else>
                            <br>Feste Adresse, kein Wächterverbund – fällt diese Maschine aus, steht der Shop.
                        </template>
                        <template v-if="speicher.grenzeMb === null">
                            Keine Speichergrenze gesetzt \u2013 Redis verdr\u00e4ngt nichts, sondern w\u00e4chst bis der
                            Arbeitsspeicher knapp wird.
                        </template>
                    </p>
                </template>
                <sw-alert v-else variant="error" :title="'Redis antwortet nicht'">
                    {{ speicher.adresse }}: {{ speicher.fehler || 'nicht erreichbar' }}
                </sw-alert>
            </sw-card>

            <sw-card v-if="warteschlangeZeilen.length" title="Warteschlange">
                <p v-for="z in warteschlangeZeilen" :key="z.name" class="rz-schlange">
                    <strong>{{ z.anzahl }}</strong> {{ z.name === 'failed' ? 'fehlgeschlagen' : z.name }}
                </p>
                <p v-if="hatFehlgeschlagene" class="rz-stand">
                    Fehlgeschlagene Aufträge bleiben liegen, bis sie jemand ansieht –
                    <span class="rz-mono">bin/console messenger:failed:show</span>
                </p>
            </sw-card>
        </sw-card-view>

        <sw-modal v-if="zeigeDialog" title="Knoten hinzunehmen" variant="small" @modal-close="zeigeDialog = false">
            <p>
                Es wird ein laufendes Frontend geklont, eingerichtet und – erst wenn es antwortet –
                an den Load Balancer gehängt. Das erzeugt einen kostenpflichtigen Server.
            </p>
            <sw-textarea-field
                v-model:value="notiz"
                label="Notiz (warum?)"
                placeholder="z. B. Aktionswoche ab Montag" />
            <template #modal-footer>
                <sw-button size="small" @click="zeigeDialog = false">Abbrechen</sw-button>
                <sw-button variant="primary" size="small" :is-loading="fordertAn" @click="anfordern">
                    Anfordern
                </sw-button>
            </template>
        </sw-modal>
    </template>
</sw-page>`,

    inject: ['loginService'],

    mixins: [Shopware.Mixin.getByName('notification')],

    data() {
        return {
            isLoading: false,
            fordertAn: false,
            fehler: null,
            knoten: [],
            datenbank: [],
            speicher: null,
            empfehlung: null,
            auftrag: null,
            warteschlange: {},
            standVon: null,
            zeigeDialog: false,
            notiz: '',
            uhr: null,
        };
    },

    computed: {
        spalten() {
            return [
                { property: 'rechnername', label: 'Knoten', primary: true },
                { property: 'lastJeKern', label: 'Last je Kern', align: 'right' },
                { property: 'fpmAuslastungProzent', label: 'PHP-Arbeiter', align: 'right' },
                { property: 'speicherFreiProzent', label: 'Speicher', align: 'right' },
                { property: 'platteFreiProzent', label: 'Platte', align: 'right' },
                { property: 'dienste', label: 'Dienste', align: 'left' },
                { property: 'gemeldetVorSekunden', label: 'Gemeldet', align: 'right' },
            ];
        },
        dbSpalten() {
            return [
                { property: 'adresse', label: 'Knoten', primary: true },
                { property: 'knotenStatus', label: 'Zustand' },
                { property: 'verbindungen', label: 'Verbindungen', align: 'right' },
                { property: 'bremst', label: 'Flusskontrolle', align: 'right' },
                { property: 'laufzeitTage', label: 'Laufzeit', align: 'right' },
            ];
        },
        waechterEinig() {
            const w = (this.speicher && this.speicher.waechter) || [];
            return w.length > 0 && w.every(x => x.erreichbar && x.kenntVerbund);
        },
        waechterText() {
            const w = (this.speicher && this.speicher.waechter) || [];
            const gut = w.filter(x => x.erreichbar && x.kenntVerbund).length;
            return `Verbund "${this.speicher.verbund}": ${gut} von ${w.length} Wächtern antworten`;
        },
        speicherBelegung() {
            if (!this.speicher) return '';
            if (this.speicher.grenzeMb === null) return `${this.zahl(this.speicher.belegtMb)} MB`;
            return `${this.speicher.belegtProzent} %`;
        },
        kannAnfordern() {
            return !this.auftrag && this.knoten.length > 0;
        },
        warteschlangeZeilen() {
            return Object.entries(this.warteschlange || {}).map(([name, anzahl]) => ({ name, anzahl }));
        },
        hatFehlgeschlagene() {
            return (this.warteschlange || {}).failed > 0;
        },
        auftragText() {
            if (!this.auftrag) return '';
            return this.auftrag.zustand === 'laeuft'
                ? 'Der Knoten wird gerade angelegt.'
                : 'Angefordert, wartet auf den Verwaltungsserver.';
        },
    },

    created() {
        this.laden();
        // Alle 30 Sekunden nachsehen: die Knoten melden sich im Minutentakt,
        // häufiger zu fragen brächte nichts.
        this.uhr = window.setInterval(() => this.laden(true), 30000);
    },

    beforeUnmount() {
        if (this.uhr) window.clearInterval(this.uhr);
    },

    methods: {
        async laden(leise = false) {
            if (!leise) this.isLoading = true;
            try {
                const antwort = await fetch(`${Shopware.Context.api.apiPath}/_action/riccardo-verbund/lage`, {
                    headers: { Authorization: `Bearer ${this.loginService.getToken()}` },
                });
                if (!antwort.ok) throw new Error(`HTTP ${antwort.status}`);
                const lage = await antwort.json();
                this.knoten = lage.knoten || [];
                this.datenbank = lage.datenbank || [];
                this.speicher = lage.speicher || null;
                this.empfehlung = lage.empfehlung || null;
                this.auftrag = lage.offenerAuftrag || null;
                this.warteschlange = lage.warteschlange || {};
                this.standVon = this.datum(lage.standVon);
                this.fehler = null;
            } catch (e) {
                this.fehler = e.message;
            } finally {
                this.isLoading = false;
            }
        },

        anfordernOeffnen() {
            this.notiz = '';
            this.zeigeDialog = true;
        },

        async anfordern() {
            this.fordertAn = true;
            try {
                const antwort = await fetch(`${Shopware.Context.api.apiPath}/_action/riccardo-verbund/anfordern`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${this.loginService.getToken()}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ notiz: this.notiz }),
                });
                const ergebnis = await antwort.json();
                if (!antwort.ok) {
                    this.createNotificationError({ message: ergebnis.grund || `HTTP ${antwort.status}` });
                } else {
                    this.createNotificationSuccess({ message: ergebnis.hinweis });
                    this.zeigeDialog = false;
                    await this.laden(true);
                }
            } catch (e) {
                this.createNotificationError({ message: e.message });
            } finally {
                this.fordertAn = false;
            }
        },

        // Alarm gibt es bei "kein Prozess" und bei zu vielen Neustarts je
        // Betriebsstunde - NICHT bei einem jungen Prozess. Nach jedem
        // Ausrollen startet der Worker neu, weil cache:clear ihm den
        // Container wegzieht; das ist normal und darf die Seite nicht
        // aufschrecken.
        dienstListe(item) {
            const namen = { worker: 'Worker', scheduler: 'Zeitplan' };
            return Object.entries(item.dienste || {}).map(([k, d]) => {
                const n = (d && d.anzahl) || 0;
                const je = d && d.neustarteJeStunde;
                if (n === 0) {
                    return { name: k, zustand: 'eng', text: `${namen[k] || k} AUS` };
                }
                if (je !== null && je !== undefined && je >= 3) {
                    return { name: k, zustand: 'eng',
                             text: `${namen[k] || k} ${n} (${je}/h Neustarts)` };
                }
                return { name: k, zustand: 'ruhig', text: `${namen[k] || k} ${n}` };
            });
        },

        dbZustand(k) {
            if (!k.erreichbar) return 'stumm';
            if (k.imVerbund && (k.verbundStatus !== 'Primary' || k.knotenStatus !== 'Synced')) return 'eng';
            if (k.bremst >= 0.1 || k.verbindungenProzent >= 80) return 'beobachten';
            return 'ruhig';
        },

        // 0 ist der Normalfall und soll nicht als "0,000" Aufmerksamkeit
        // ziehen - interessant wird der Wert erst, wenn er nicht 0 ist.
        bremse(wert) {
            if (wert === null || wert === undefined) return '\u2013';
            return wert === 0 ? 'keine' : `${(wert * 100).toFixed(1)} %`;
        },

        zahl(wert) {
            return wert === null || wert === undefined ? '–' : Number(wert).toLocaleString('de-DE');
        },

        vorher(sekunden) {
            if (sekunden === null || sekunden === undefined) return '–';
            if (sekunden < 90) return `${sekunden} s`;
            const minuten = Math.round(sekunden / 60);
            if (minuten < 90) return `${minuten} Min.`;
            return `${Math.round(minuten / 60)} Std.`;
        },

        datum(wert) {
            if (!wert) return '';
            return new Date(wert.replace(' ', 'T')).toLocaleString('de-DE');
        },
    },
};
